module.exports = __webpack_public_path__ + "media/images/front/common/icon_life_style-881243a2e87c9d532da88313328fe5b8.svg";